import { useMutation } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiMetaData,
  V3ApiSuccessData,
  V3ApiErrorData,
} from 'javascripts/services/v3ApiClient';

type ResponseObject = {
  data: {
    id: number;
  };
  meta: V3ApiMetaData;
  errors: [];
};

export type StartSampleResponse = V3ApiSuccessData<ResponseObject[]>;

export const useStartSample = ({
  onError,
  onSuccess,
}: {
  onError?: (error: any) => void;
  onSuccess?: (error: any) => void;
}) => {
  const { isError, data, isSuccess, mutate } = useMutation<
    StartSampleResponse,
    V3ApiErrorData,
    { productId: string }
  >({
    mutationFn: async ({ productId }: { productId: string }) => {
      const response = await request({
        url: `accounts/trials`,
        method: 'POST',
        data: {
          accountTrial: {
            productId: Number(productId),
          },
        },
      });
      return response.data;
    },
    onError,
    onSuccess,
  });

  return {
    data,
    isError,
    isSuccess,
    mutate,
  };
};
